import Script from 'next/script';

import { useConsentManager } from './consent-manager';

declare global {
  interface Window {
    /** Navattic queue for deferred function calls */
    navatticQueue?: Array<{
      function: string;
      arguments: unknown[];
    }>;
    /** Navattic SDK proxy */
    navattic?: Record<string, (...args: unknown[]) => void>;
  }
}

/**
 * Load the Navattic scripts after airgap.js is initialized
 */
export const NavatticPixelScript: React.FC = () => {
  const { airgap } = useConsentManager();

  const loadScript = airgap || process.env.VERCEL_ENV !== 'production';

  return (
    <>
      {loadScript && (
        <>
          {/* Initialize Navattic queue before SDK loads */}
          <Script
            id="navattic-init"
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `void 0===window.navatticQueue&&(window.navatticQueue=[],window.navattic=new Proxy({},{get:function n(t,u,e){return function(){for(var n=arguments.length,t=Array(n),e=0;e<n;e++)t[e]=arguments[e];return navatticQueue.push({function:u,arguments:t})}}}));`,
            }}
          />
          {/* Navattic SDK script */}
          <Script
            id="navattic-sdk"
            src="https://js.navattic.com/sdk.js?key=pkey_cmhl1jy02001w04lb3wagbl6c"
            strategy="lazyOnload"
            async
          />
        </>
      )}
    </>
  );
};
